
import { Upload } from "antd";
import FormRemark from "../../form/FormRemark";
import FormInputError from "../../form/FormInputError";
import React, { useEffect,useState } from "react";
import FormContentCheckbox from "../../form/FormContentCheckbox";
import './index.less';
import { useTranslation } from "react-i18next";
import useApplyNewStore from "../../../store/useApplyNewStore";
import useLoadingStore from "../../../store/useLoadingStore";
import { apiDomain, basename, isProduction } from "../../../setting";
import useAuthStore from "../../../store/useAuthStore";
import feWriteLog from "../../../function/feWriteLog";
import useModalStore from "../../../store/useModalStore";



const SectionUpload = ({
  type = "",
  onOption1Click,
  onOption2Click,
  option1Title = "上傳文件",
  option2Title = "稍後提供文件",
  option2Hidden = false,
  option2Disabled = false,
  children,
  ...props
}) => {
  const { t } = useTranslation();
  // type=LOG时锁定上传文件
  const isLOG = type === "LOG";
  // 互斥激活状态
  const { isStep1Valid, step1_notToPaid, } = useApplyNewStore();
  const { step2_upload_option1, setStep2_upload_option1 } = useApplyNewStore();
  const { step2_upload_option2, setStep2_upload_option2 } = useApplyNewStore();
  const { step2_doc, setStep2_doc, addStep2_doc } = useApplyNewStore();
  const { step2_doc_error, setStep2_doc_error } = useApplyNewStore();
  const { step2_doc_option_error, setStep2_doc_option_error } = useApplyNewStore();
  const { getPreAuthFormData, validateStep2 } = useApplyNewStore();
  const { step2_scrollTo, setStep2_scrollTo } = useApplyNewStore();
  const { setLoading } = useLoadingStore();
  const { token, logout } = useAuthStore();
  const { openModalInfo } = useModalStore();

  useEffect(() => {
    window.scrollTo(0, 0);

    // if (isStep1Valid === false || !step1_notToPaid) {
    //   setStep2_upload_option2(false);
    //   validateStep2();
    // }
  }, []);

  const handleOption1Click = () => {
    if (!isLOG) {
      setStep2_upload_option1(true);
      setStep2_upload_option2(false);
      setStep2_doc_option_error(false);
      validateStep2(true);
    }
    if (onOption1Click) onOption1Click();
  };
  const handleOption2Click = () => {
    if (!isLOG) {
      setStep2_upload_option1(false);
      setStep2_upload_option2(true);
      setStep2_doc_option_error(false);
      validateStep2(true);

    }
    if (onOption2Click) onOption2Click();
  };

  const uploadProps = {
    name: 'file',
    multiple: true,
    listType: 'picture',
    fileList: step2_doc,
    iconRender: (file, listType) => {
      if (file.contenttype === "application/pdf") {
        return <img src={`${process.env.PUBLIC_URL}/images/document-doc.svg`} alt={file.name} style={{ width: "100%", height: "100%" }} />;
      } else {
        return <img src={file.orgUrl} alt={file.name} style={{ width: 24, height: 24 }} />;
      }
    },
    onChange: (info) => {
      // console.log("upload file", info.file)
    },
    beforeUpload: async (file, fileList) => {
      try {
        setLoading(true);
        const allowedFileTypes = ['image/png', 'image/jpeg', 'application/pdf', 'image/gif', 'image/tiff', 'image/tif'];
        const isAllowedFileType = allowedFileTypes.includes(file.type);
        if (!isAllowedFileType) {
          setLoading(false);
          throw new Error('File Type Error');
        }

        const isFileSizeValid = file.size <= 20 * 1024 * 1024; // 20MB in bytes
        if (!isFileSizeValid) {
          setLoading(false);
          throw new Error('File Size Error');
        }

        // console.log("upload file", file, fileList)
        const formData = new FormData();
        formData.append('file', file);
        formData.append('attachid', getPreAuthFormData?.form.appattachid);
        formData.append('module', 'PREAUTH');

        const response_upload = await fetch(`${apiDomain}/${basename}/api/general/uploadFile`, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`
          },
          body: formData,
        });

        if (response_upload.status === 401) { // Unauthorized
          logout();
          setLoading(false);
          throw new Error('Unauthorized');
        }

        if (!response_upload.ok) {
          setLoading(false);
          throw new Error('Network Error');
        }

        const data_upload = await response_upload.json();
        // console.log("uploaded file", data_upload)
        const { attachid, attachobjid, contenttype, ofilename } = data_upload.attachment;

        const response_download = await fetch(`${apiDomain}/${basename}/api/general/download/${attachobjid}?isthumb=squ`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`
          },
        });

        if (response_download.status === 401) { // Unauthorized
          logout();
          setLoading(false);
          throw new Error('Unauthorized');
        }

        if (!response_download.ok) {
          setLoading(false);
          throw new Error(`Network Error`);
        }

        const data_download = await response_download.json();
        // console.log(data_download);

        const response_downloadOrg = await fetch(`${apiDomain}/${basename}/api/general/download/${attachobjid}?isthumb=N`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`
          },
        });

        if (response_downloadOrg.status === 401) { // Unauthorized
          logout();
          setLoading(false);
          throw new Error('Unauthorized');
        }

        if (!response_downloadOrg.ok) {
          setLoading(false);
          throw new Error(`Network Error`);
        }

        const data_downloadOrg = await response_downloadOrg.json();

        addStep2_doc({
          attachid: attachid,
          attachobjid: attachobjid,
          name: ofilename,
          contenttype: contenttype,
          url: data_download,
          orgUrl: data_downloadOrg,
        });

        setStep2_doc_error(false);
        validateStep2(true);

        // checkIsStep2_2Valid(true);
        setLoading(false);

      } catch (error) {
        feWriteLog(`Error: ${error.message}`);
        if (error.message === "Unauthorized") {
          openModalInfo({
            id: isProduction ? "pre_auth_error_expiry" : "pre_auth_uat_error_expiry",
            title: t("error:unauthorized.title"),
            text: t("error:unauthorized.message")
          });
          // setStep("loading");
        } else if (error.message === "Network Error") {
          openModalInfo({
            id: isProduction ? "pre_auth_error_network" : "pre_auth_uat_error_network",
            title: t("error:network.title"),
            text: t("error:network.message")
          });
        } else if (error.message === "File Type Error") {
          openModalInfo({
            id: isProduction ? "pre_auth_error_file_type" : "pre_auth_uat_error_file_type",
            title: t("error:fileFormat.title"),
            text: t("error:fileFormat.message")
          });
        } else if (error.message === "File Size Error") {
          openModalInfo({
            id: isProduction ? "pre_auth_error_file_size" : "pre_auth_uat_error_file_size",
            title: t("error:fileSize.title"),
            text: t("error:fileSize.message")
          });
        } else {
          openModalInfo({
            id: isProduction ? "pre_auth_error_unknown" : "pre_auth_uat_error_unknown",
            title: t("error:unknown.title"),
            text: t("error:unknown.message")
          });
        }

        setLoading(false);

        return false;
      }

      return false;
    },
    onPreview: (file) => {
      const link = document.createElement('a');
      link.href = file.orgUrl;
      link.download = file.name;
      link.click();
    },
    onRemove: (file) => {
      fetch(`${apiDomain}/${basename}/api/general/delete/${file.attachobjid}`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`
        },
      });

      setStep2_doc(step2_doc.filter(f => f.attachobjid !== file.attachobjid));
      validateStep2(true);
      // checkIsStep2_2Valid(true);
    },
  };


  return (
    <div className="apply-step-upload-section" {...props}>
      <div className="apply-step-upload-title">
        <img className="apply-step-upload-img32" src={`${process.env.PUBLIC_URL}/images/tray-arrow-u.svg`} alt={t("translation:apply.step1.sectionNew.Upload.section1.title")} />
        <h4>{t("translation:apply.step1.sectionNew.Upload.section1.title")}</h4>
      </div>
      {!isLOG && (
        <div className="apply-step-upload-content">
          <FormContentCheckbox
            title={t("translation:apply.step1.sectionNew.Upload.section1.option1_title")}
            active={step2_upload_option1}
            onClick={handleOption1Click}
            id="apply_step2_upload_option1"
          />
          <FormContentCheckbox
            title={t("translation:apply.step1.sectionNew.Upload.section1.option2_title")}
            active={step2_upload_option2}
            onClick={handleOption2Click}
            disabled={option2Disabled}
            style={option2Disabled ? { opacity: 0.5, pointerEvents: "none" } : {}}
            id="apply_step2_upload_option2"
          />
        </div>
      )}
      {(isLOG || step2_upload_option1) && (
        <div id="apply_step2_upload_file" className="apply-step-upload-detail">
          <div className="apply-step-upload-desc" >
            {t("translation:apply.step1.sectionNew.Upload.section1.option1_content")}
          </div>
          <Upload.Dragger {...uploadProps} id="apply_step2_upload_file_uploader" className="apply-step-upload-uploader" >
            <div className="apply-step-upload-uploader-content">
              <img
                src={`${process.env.PUBLIC_URL}/images/tray-arrow-u-circle.svg`}
                style={{ width: 48, height: 48 }}
                alt={t("translation:apply.step1.sectionNew.Upload.section1.option1_upload")}
              />
              <div className="apply-step-upload-uploader-text">
                {t("translation:apply.step1.sectionNew.Upload.section1.option1_upload")}
              </div>
            </div>
          </Upload.Dragger>
          <FormRemark style={{ color: "#262626" }}>{t("translation:apply.step1.sectionNew.Upload.section1.option1_upload_remark")}</FormRemark>
          <FormInputError show={step2_doc_error}>
            * {t("translation:apply.step1.sectionNew.Upload.section1.error_doc")}
          </FormInputError>
        </div>
      )}
      {step2_upload_option2 && !isLOG && (
        <div id="apply_step2_upload_file_later" className="apply-step-upload-detail">
          <div className="apply-step-upload-desc">
            {t("translation:apply.step1.sectionNew.Upload.section1.option2_content")}
          </div>
        </div>
      )}
    </div>
  );
};
export default SectionUpload;


